<template>
	<fieldset id="fs-schematic" class="pt-3 pb-3">
		<div class="container pt-5 pb-3">
			<div class="row no-gutters">
				<div class="fieldset-title">
					<i class="icon">
						<svg aria-hidden="true">
							<use xlink:href="/static/build/gfx/sprite.svg#icon-recirc"/>
						</svg>
					</i>

					<h2 class="heading">Piping Configuration</h2>
				</div>
			</div>

			<div class="row mt-3">
				<div class="btn-group">
					<button
						type="button"
						@click.prevent="userToggledSection = 'electric'"
						:class="{
							toggled: isElectricOpen,
							btn: true,
							'btn-box': true,
							'js-btn-option': true,
						}"
					>
						<span>Electric Heating Configurations</span>
					</button>

					<button
						type="button"
						@click.prevent="userToggledSection = 'dualFuel'"
						:class="{
							toggled: isDualFuelOpen,
							btn: true,
							'btn-box': true,
							'js-btn-option': true,
						}"
					>
						<span>Supplemental Heating</span>
					</button>
				</div>
			</div>

			<div class="row mt-3">
				<ElectricHeatingOpts :isOpen="isElectricOpen" />

				<DualFuelOpts :isOpen="isDualFuelOpen" />
			</div>

			<div class="row mt-2"></div>

			<div class="row mt-5 clearfix">
				<AdvancedOpts
					v-if="['swingtank', 'paralleltank', 'sprtp', 'mprtp', 'sprtp_series', 'mprtp_series', 'gas_swingtank', 'gas_parallel'].includes(formData.schematic)"
				/>
			</div>
		</div>
	</fieldset>
</template>

<script>
import AdvancedOpts from './components/AdvancedOpts'
import ElectricHeatingOpts from './components/ElectricHeatingOpts'
import DualFuelOpts from './components/DualFuelOpts'
import formData from '@/components/Sizer/form-data-store'
import sizerStore from '@/components/Sizer/sizer-store'

const DUAL_FUEL_SCHEMATICS = ['sprtp_series', 'mprtp_series', 'gas_swingtank', 'gas_parallel']

export default {
	name: 'Schematic Select',

	components: {
		AdvancedOpts,
		ElectricHeatingOpts,
		DualFuelOpts,
	},

	data: () => ({
		formData,
		sizerStore,
		userToggledSection: null, // null | 'electric' | 'dualFuel'
	}),

	computed: {
		openSection () {
			if (this.userToggledSection) return this.userToggledSection

			// Follow whichever family the selected schematic belongs to. Deriving
			// this from formData rather than from a result means a failed run -
			// which leaves sizerStore.out empty - keeps the user where they were
			// instead of snapping back to Electric Heating.
			return DUAL_FUEL_SCHEMATICS.includes(formData.schematic) ? 'dualFuel' : 'electric'
		},

		isElectricOpen () {
			return this.openSection === 'electric'
		},

		isDualFuelOpen () {
			return this.openSection === 'dualFuel'
		},
	},

	watch: {
		'sizerStore.out' (newOut) {
			// A completed sizing run always dictates which section is open,
			// overriding any manual toggle made before the run. An errored run
			// clears `out`, and must leave the user's choice alone.
			if (newOut) this.userToggledSection = null
		},
	},
}
</script>
